<template>
    <v-card>
        <v-card-title>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="create" v-if="userIsFleetManager">Create Announcement</v-btn>
        </v-card-title>
        <v-data-table
            :items="announcements"
            :headers="headers"
            :loading="$wait.is(['loading announcements'])"
        >
            <v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>
            <template v-slot:item="props">
                <tr>
                    <td>{{props.item.title}}</td>
                    <td>{{moment(props.item.createdOn) | formatDate}}</td>
                    <td>{{!props.item.publishedOn ? '' : moment(props.item.publishedOn) | formatDate }}</td>
                    <td class="pl-0" v-if="userIsFleetManager">
                        <v-btn @click="show(props.item)" icon>
                            <v-icon>edit</v-icon>
                        </v-btn>
                        <v-btn v-if="userIsFleetManager" @click="confirmDelete(props.item)" icon small color="red">
                            <v-icon>delete</v-icon>
                        </v-btn>
                    </td>
                </tr>
            </template>
            <template v-slot:no-results>
                <v-layout row align-center>
                    <v-flex>No matching records found</v-flex>
                </v-layout>
            </template>
        </v-data-table>
        <announcement-modal ref="announcement"></announcement-modal>
    </v-card>
</template>
<script>
import AnnouncementClient from '@/components/Announcements/AnnouncementClient.vue';
import AnnouncementModal from '@/components/Announcements/AnnouncementModal.vue';
import { Event, EventBus } from '@/plugins/bus';

export default {
  mixins: [AnnouncementClient],
  components: { AnnouncementModal },
  data() {
    return {
      announcements: [],
      loading: true,
      headers: [
        { text: 'Title', value: 'title' },
        { text: 'Created', value: 'createdOn' },
        { text: 'Published', value: 'publishedOn' },
        { text: '', value: '', sortable: false },
      ]
    };
  },
  methods: {
    show(announcement) {
      this.$refs.announcement.show(announcement);
    },
    create() {
      this.$refs.announcement.create();
    },
    async load() {
      const response = await this.getAnnouncements();
      if (response && response.data.length > 0) {
        this.announcements = response.data
          .map((announcement) => ({seenOn: null, ...announcement}));
      }
    },
    confirmDelete(announcement) {
      this.$confirmCancel.show(`Delete Announcement?`, `<p>This will permanently delete this announcement</p>`, 'Delete it');
      this.$confirmCancel.$on('confirm-cancel', confirmed => {
        if (!confirmed) {
          return;
        }
        this.$bus.$emit(Event.AnnouncementDeleted, {
          id: announcement.id,
        });
      });
    },
    async handlerAnnouncementDeleted(announcement) {
      await this.deleteAnnouncement(announcement.id);
      await this.load();
    }
  },
  async created() {
    await this.load();
    EventBus.$on(Event.AnnouncementUpdated, this.load);
    EventBus.$on(Event.AnnouncementDeleted, this.handlerAnnouncementDeleted);
  },
  destroyed() {
    EventBus.$off(Event.AnnouncementUpdated, this.load);
    EventBus.$off(Event.AnnouncementDeleted, this.handlerAnnouncementDeleted);
  }
};
</script>
